import { render, staticRenderFns } from "./Crown.vue?vue&type=template&id=177f959f"
import script from "./Crown.vue?vue&type=script&lang=js"
export * from "./Crown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports